import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { GeneralService } from './general.service';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';
import { MessageService } from 'primeng/components/common/messageservice';
import { ParkingTicketFilter } from '../models/parkingTicketFilter.model';
import { Observable } from 'rxjs';
import { ResponseModel } from '../models';


@Injectable()
export class ParkingPriceService extends GeneralService {
    constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
        super(messageService, httpClient, persistenceService, environment.apiPostUrl, "ParkingPrice");
    }

    async getParkingPriceById(id: any): Promise<ResponseModel> {
        let params = new HttpParams();
        params = params.append("id", id);
        return await super.getCustomApi("GetParkingPriceById", params).toPromise();
    }

    async getParkingPriceByCode(code: any): Promise<ResponseModel> {
        let params = new HttpParams();
        params = params.append("code", code);
        return await super.getCustomApi("GetByCode", params).toPromise();
    }

    async listParkingPriceByCode(code: any, pageNumber:any, pageSize:any): Promise<ResponseModel> {
        let params = new HttpParams();
        params = params.append("code", code);
        params = params.append("pageNumber", pageNumber);
        params = params.append("pageSize", pageSize);
        return await super.getCustomApi("GetListParkingPrice", params).toPromise();
    }
}